<template>
	<div class="edit-row edit-row--b-top">
		<div class="edit-row__label">{{ t('quickEditBar.nav') }}</div>
		<field-select
			:label="t('quickEditBar.prev')"
			:label-inline="true"
			:disabled="blocked"
			:options="nodesIds"
			:options-available="nodesPrevAvailable"
			v-model:selected="nodePrevious"
			:select-classname="'field--w-99'"
			:class="'mod--edit-bar mode--label-w-normal'"
			:by-value="'value'"
			:property="'name'"
		></field-select>
		<field-select
			:label="t('quickEditBar.next')"
			:label-inline="true"
			:disabled="blocked"
			:options="nodesIds"
			:options-available="nodesNextAvailable"
			v-model:selected="nodeNext"
			:select-classname="'field--w-99'"
			:class="'mod--edit-bar mode--label-w-normal'"
			:by-value="'value'"
			:property="'name'"
		></field-select>
	</div>
</template>

<script>
import FieldSelect from '@/components/fields/FieldSelect';
import {computed} from 'vue';
import {useStore} from 'vuex';
import {useI18n} from 'vue-i18n';

export default {
	components: {
		FieldSelect,
	},
	props: {
		blocked: {
			type: Boolean,
			default: false,
		}
	},
	setup() {
		const {t} = useI18n();
		const store = useStore();
		const currentLang = computed(() => store.getters["maps/languages/getLanguage"].id);
		
		const currentNodeOriginal = computed(() => store.getters["nodes/getSelectedRawNode"])
		const nodesOriginal = computed(() => store.getters["nodes/getRawNodes"]);
		const nodesIds = computed(() => [{name: 'None', value: null}, ...nodesOriginal.value.map(node => {
			return {
				value: node.id,
				name: `${node.id} - ${node.content.lang[currentLang.value].title?.substring(0, 10)}`
			}
		})]);
		const nodeNext = computed({
			get(){return currentNodeOriginal.value.content.navigation.next_id === null ? 'None' : currentNodeOriginal.value.content.navigation.next_id},
			set(value){
				if(value === 'None') value = null;
				nodeUpdateContent({navigation: {next_id: value, previous_id: currentNodeOriginal.value.content.navigation.previous_id}});
				nodeSaveContent({navigation: {next_id: value, previous_id: currentNodeOriginal.value.content.navigation.previous_id}});
			}
		})
		const nodePrevious = computed({
			get(){return currentNodeOriginal.value.content.navigation.previous_id === null ? 'None' : currentNodeOriginal.value.content.navigation.previous_id},
			set(value){
				if(value === 'None') value = null;
				nodeUpdateContent({navigation: {previous_id: value, next_id: currentNodeOriginal.value.content.navigation.next_id}});
				nodeSaveContent({navigation: {previous_id: value, next_id: currentNodeOriginal.value.content.navigation.next_id}});
			}
		})
		const nodesNextAvailable = computed(() => nodesIds.value.filter(node => node.value === null || node.value !== currentNodeOriginal.value.content.navigation.previous_id));
		const nodesPrevAvailable = computed(() => nodesIds.value.filter(node => node.value === null || node.value !== currentNodeOriginal.value.content.navigation.next_id))
		
		function nodeUpdateContent(content){
			const id = currentNodeOriginal.value.id;
			store.dispatch('nodes/content/nodeUpdateContent', {id, content});
		}
		async function nodeSaveContent(content){
			const id = currentNodeOriginal.value.id;
			await store.dispatch('nodes/content/nodeSaveContent', {id, content});
		}
		
		return{
			t,
			nodesIds,
			nodesNextAvailable,
			nodeNext,
			nodePrevious,
			nodesPrevAvailable
		}
		
	}
}
</script>

<style lang="scss">

</style>
